import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router';
import './BottomNavigation.css';

// Nav 탭 경로를 저장하는 키
export const LAST_NAV_TAB_KEY = 'last_nav_tab';

export const BottomNavigation: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const isActive = (path: string) => location.pathname === path;

    // 현재 경로를 마지막 탭으로 저장
    useEffect(() => {
        const navPaths = ['/home', '/functions', '/chat', '/settings'];
        if (navPaths.includes(location.pathname)) {
            sessionStorage.setItem(LAST_NAV_TAB_KEY, location.pathname);
        }
    }, [location.pathname]);

    const handleNavClick = (path: string) => {
        sessionStorage.setItem(LAST_NAV_TAB_KEY, path);
        // 메인 탭 이동 시 히스토리 초기화 (replace)
        navigate(path, { replace: true });
    };

    return (
        <div className="bottom-navigation">
            <button
                className={`nav-item ${isActive('/home') ? 'active' : ''}`}
                onClick={() => handleNavClick('/home')}
            >
                <div className="nav-icon">🏠</div>
                <div className="nav-label">홈</div>
            </button>
            <button
                className={`nav-item ${isActive('/functions') ? 'active' : ''}`}
                onClick={() => handleNavClick('/functions')}
            >
                <div className="nav-icon">➕</div>
                <div className="nav-label">주요기능</div>
            </button>
            <button
                className={`nav-item ${isActive('/chat') ? 'active' : ''}`}
                onClick={() => handleNavClick('/chat')}
            >
                <div className="nav-icon">💬</div>
                <div className="nav-label">채팅</div>
            </button>
            <button
                className={`nav-item ${isActive('/settings') ? 'active' : ''}`}
                onClick={() => handleNavClick('/settings')}
            >
                <div className="nav-icon">⚙️</div>
                <div className="nav-label">설정</div>
            </button>
        </div>
    );
};
